import { Routes } from '@angular/router';

export const depositoRoutes: Routes = [
  {
    path: 'deposito',
    canActivate: [() => import('../../core/guards/deposito.guard').then(m => m.depositoGuard)],
    loadComponent: () => import('./layout/layout.component').then(m => m.DepositoLayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'produtos',
        loadComponent: () => import('./produtos/produtos.component').then(m => m.ProdutosComponent)
      },
      {
        path: 'pedidos',
        loadComponent: () => import('./pedidos/pedidos.component').then(m => m.PedidosComponent)
      },
      {
        path: 'farmacias',
        loadComponent: () => import('./farmacias/farmacias.component').then(m => m.FarmaciasComponent)
      },
      {
        path: 'perfil',
        loadComponent: () => import('./perfil/perfil.component').then(m => m.PerfilComponent)
      },
      {
        path: 'relatorios',
        loadComponent: () => import('./relatorios/relatorios.component').then(m => m.RelatoriosComponent)
      },
      {
        path: 'notificacoes',
        loadComponent: () => import('./notificacoes/notificacoes.component').then(m => m.NotificacoesComponent)
      },
      {
        path: 'configuracoes',
        loadComponent: () => import('./configuracoes/configuracoes.component').then(m => m.ConfiguracoesComponent)
      },
      {
        path: 'entregas',
        loadComponent: () => import('./entregas/entregas.component').then(m => m.EntregasComponent)
      },
      {
        path: 'debug',
        loadComponent: () => import('./debug/debug.component').then(m => m.DebugComponent)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  }
];
